import { useState, useEffect } from "react";
import axios from "axios";
import { API, useAuth } from "../App";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Award, Calendar, Download, Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";

const Certificates = () => {
  const { token } = useAuth();
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCertificates();
  }, []);

  const fetchCertificates = async () => {
    try {
      const response = await axios.get(`${API}/certificates`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCertificates(response.data);
    } catch (error) {
      console.error("Error fetching certificates:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background" data-testid="certificates-page">
      <Navbar />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-12 h-12 bg-accent/20 rounded-lg flex items-center justify-center">
            <Award className="w-6 h-6 text-accent" />
          </div>
          <div>
            <h1 className="text-3xl font-heading font-bold">Mes Certificats</h1>
            <p className="text-muted-foreground">
              Vos accomplissements et certifications
            </p>
          </div>
        </div>

        {certificates.length === 0 ? (
          <div className="bg-card border border-border rounded-lg p-12 text-center">
            <Award className="w-16 h-16 text-muted-foreground mx-auto mb-4" />
            <h2 className="text-xl font-heading font-bold mb-2">
              Aucun certificat pour le moment
            </h2>
            <p className="text-muted-foreground mb-4">
              Terminez un cours pour obtenir votre premier certificat.
            </p>
            <Button onClick={() => window.location.href = "/courses"}>
              Explorer les cours
            </Button>
          </div>
        ) : (
          <div className="grid gap-6" data-testid="certificates-list">
            {certificates.map((cert) => (
              <div
                key={cert.certificate_id}
                className="bg-card border border-border rounded-lg overflow-hidden"
              >
                <div className="bg-gradient-to-r from-accent/20 to-primary/20 p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex items-center gap-4">
                      <div className="w-16 h-16 bg-background rounded-lg flex items-center justify-center">
                        <Award className="w-8 h-8 text-accent" />
                      </div>
                      <div>
                        <h3 className="text-xl font-heading font-bold mb-1">
                          {cert.course_title}
                        </h3>
                        <p className="text-muted-foreground">
                          Délivré à {cert.user_name}
                        </p>
                      </div>
                    </div>
                    <Button variant="outline" size="sm">
                      <Download className="w-4 h-4 mr-2" />
                      Télécharger
                    </Button>
                  </div>
                </div>
                <div className="p-4 border-t border-border flex items-center gap-4 text-sm text-muted-foreground">
                  <span className="flex items-center gap-1">
                    <Calendar className="w-4 h-4" />
                    Délivré le {new Date(cert.issued_at).toLocaleDateString("fr-FR")}
                  </span>
                  <span className="font-mono text-xs">
                    ID: {cert.certificate_id}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default Certificates;
